<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs">
  <div class="cards-holder">
    <div class="card card3 mRight sem-calls-left">
      <app-loader [showLoader]=showLoad></app-loader>
      <div class="c-portlet__header">
        <div class="o-stack__cell">
          <h5 class="card-title">Time and Duration of Calls</h5>
					<span class="datatable-icon" *ngIf="graphData.length>0">
							<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSVData($event)" target="_blank"
								 *ngIf="downloadConfiguration && downloadConfiguration.enableDownload">
									<i class="fa fa-download" aria-hidden="true"></i>
							</a>
					</span>
				</div>
      </div>
      <div *ngIf="hasData">
        <div class="legend-divider">
          <div class="chart-legends-left">
            <div class="rates">
              <div class="subtext-font ">Avg. Duration (HH:MM:SS)</div>
              <div class="sem_calls_metrics">{{metricsData?.avgDuration}}
              </div>
            </div>
            <div class="rates">
              <div class="subtext-font" *ngIf="!graphFilterDisabled">Total Answered Calls</div>
              <div class="subtext-font" *ngIf="graphFilterDisabled">Total Number of Calls</div>
              <div class="sem_calls_metrics">{{metricsData?.answeredCalls | number:'1.0-2'}}
              </div>
            </div>
            <div class="rates">
              <div class="subtext-font">Total Missed Calls</div>
              <div class="sem_calls_metrics">{{metricsData?.missedCalls | number:'1.0-2'}}
              </div>
            </div>
          </div>
          <div class="chart-legends-right" [ngClass]="{'filter_disabled': graphFilterDisabled}">
              <p>Filter answered calls:</p>
              <div class="filters">
               <div *ngFor="let graphFilterOption of graphFilterOptions" class="filter_item"  [ngClass]="{'active_item primary-color-bg': selectedValue == graphFilterOption.id}" (click)="filterChange(graphFilterOption.id)">
                {{graphFilterOption.name}}
              </div>
            </div>
          </div>
        </div>
        <div class="calls-graph-area">
          <div>
            <div id="chart" #graphArea></div>
          </div>
        </div>
      </div>
      <div class="no-data-container" *ngIf="!hasData">
        <div class="map-no-data">No Data to Display</div>
      </div>
    </div>
  </div>
</div>
